module.exports = __webpack_public_path__ + "img/feedbackvalidation-jddetails.d8eaade6.svg";